import styled from "styled-components";

const ProfileContainer = styled.div`
    display: flex;
    padding-bottom: .75rem;
`;

export default ProfileContainer;